<template>
  <div class="page wrap">
    <sysmenu></sysmenu>
    <div :class="['rightcontent', $store.state.leftmenu ? '' : 'expand']">
      <GlobalHeader :enterInfo="enterInfo"></GlobalHeader>
      <div class="rightpage">
        <router-view />
      </div>
    </div>


  </div>
</template>

<script>
import sysmenu from "./menu/menu.vue";
import GlobalHeader from './Components/GlobalHeader.vue'

export default {
  components: {
    sysmenu, GlobalHeader
  },
  data() {
    return {
      showmenu: 1,
      mainbg: "",
      expand: false,
      enterInfo: {
        enterStatus: 0,
        enterName: ""
      },
    };
  },
  mounted() {
    this.getConfig();
    this.getTeacher();

  },
  methods: {
    hideMenu() {
      if (this.$store.state.leftmenu) {
        this.$store.dispatch("showSmenu", 0)
      } else {
        this.$store.dispatch("showSmenu", 1)
      }

    },
    getTeacher() {
      this.$http.post("/api/enterprise_info", {}).then(res => {
        if (res.data) {
          this.enterInfo = res.data
          this.enterInfo.enterName = res.data.firm_name;
          this.enterInfo.enterStatus = res.data.check_status;
            //更新天眼查
            this.$http.post("/api/tyc_search", {enter_name:res.data.firm_name}).then(res2 => {
           
          });
        }
      });
      this.$http.post("/api/check_enter_info", {}).then(res => {
        if (res.data && res.data.utype != 2) {
          this.$router.push("/login")
        } else {
        
        }
      });
    },
    getConfig() {
      if (localStorage.getItem("config")) {
        let config = JSON.parse(localStorage.getItem("config"));
        this.$store.dispatch("setConfig", config);
        if (config.favico) {
          var link = document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = config.favico;
          document.getElementsByTagName("head")[0].appendChild(link);
        }
        if (config.schoolname) {
          document.title = "企业招聘-" + config.schoolname;
        }
      }
      this.$http.post("/api/sch_configs").then(res => {
        let config = {}
        for (let k of res.data) {
          config[k.ktype] = k.kvalue
        }

        if (config.favico) {
          var link = document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = config.favico;
          document.getElementsByTagName('head')[0].appendChild(link);
        }
        if (config.schoolname) {
          document.title = "企业招聘" + "-" + config.schoolname
        }

        this.$store.dispatch("setConfig", config);
        localStorage.setItem("config", JSON.stringify(config));
      });
    }
  }
};
</script>
<style scoped>
.page {
  position: relative;
  overflow: hidden;
  background-size: cover;
}

.rightcontent {
  margin-left: 256px;
  width: calc(100% - 256px);
  height: 100%;
  transition: margin .3s;
  background-color: #f0f2f5;
}

.expand {
  margin-left: 64px;
  width: calc(100% - 64px);
}

.rightpage {
  /* box-shadow: -2px -2px 6px 2px rgba(24, 144, 255, 0.1),
 2px 2px 6px 2px rgba(24, 144, 255, 0.1);  */
  border-radius: 8px;
  overflow: hidden;
  height: calc(100% - 64px);
  box-sizing: border-box;
  padding: 15px 30px 10px 10px;

}
</style>

